import React from 'react';

const Header = () => {
  return (
    <header className="bg-quantum-gray p-4 border-b border-quantum-blue">
      <div className="container mx-auto flex items-center justify-between">
        <h1 className="text-2xl font-bold text-quantum-blue">
          QuantumSphere Command Center
        </h1>
      </div>
    </header>
  );
};

export default Header;